import React from 'react';
import { Col, Placeholder } from 'react-bootstrap';
import CardLayout from '../../../../../shared/components/card/CardLayout';

export function UserAndRolesCardSkeleton() {
    return (
        <Col lg={3} className="mb-4" aria-hidden="true">
            <CardLayout classBody="d-flex flex-column justify-content-center align-items-center">
                <Placeholder as="div" animation="glow" className="w-100 d-flex flex-column align-items-center">
                    <Placeholder className="skeleton skeleton-user-avatar-lg " />
                    <Placeholder className="skeleton skeleton-table-name d-block mt-3" />
                    <Placeholder className="skeleton skeleton-stat-label d-block mt-2" />
                    <Placeholder xs={8} className="skeleton d-block mt-2" />
                    <Placeholder className="skeleton skeleton-outline-btn skeleton-btn-block d-block mt-2" />
                </Placeholder>
            </CardLayout>
        </Col>
    );
}

export function UserAndRolesHeaderSkeleton() {
    return (
        <Placeholder as="div" animation="glow" className="d-flex align-items-center" aria-hidden="true">
            <div className="d-flex flex-column align-items-end mr-2">
                <Placeholder className="skeleton skeleton-table-name d-block" />
                <Placeholder className="skeleton skeleton-stat-label d-block mt-2" />
            </div>
            <Placeholder className="skeleton skeleton-company-logo d-none d-md-block" />
        </Placeholder>
    );
}
